module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%// START A/B TEST PLGRWEB-1380 - Browse Filter on \"All\" %>\n<div class=\"browse-filters-wrapper\">\n    <div class=\"filter-dropdown\">\n        <ul id=\"genre-dropdown\" class=\"dropdown js-dropdown\">\n            <li class=\"pv-h\">\n                <label class=\"genre-label\" aria-label=\"Genre\" for=\"genre-dropdown\">Genre</label>\n                <span id=\"genre-text\" class=\"active-genre\"></span>\n                <span class=\"filter\"></span>\n                <ul class=\"content filter_list_item\">\n                <% for (var key in genres) { %>\n                    <li role=\"option\">\n                        <a href=\"#\"\n                           class=\"genre-filter\"\n                           data-val=\"<%= genres[key].value %>\"\n                           role=\"button\" \n                           tabindex=\"0\"\n                           aria-label=\"<%= genres[key].title %>\">\n                            <%= genres[key].title %>\n                        </a>\n                    </li>\n                <% } %>\n                </ul>\n            </li>\n        </ul>\n    </div>\n    <% if (brands) { %>\n        <div class=\"filter-dropdown\">\n            <ul id=\"brand-dropdown\" class=\"dropdown js-dropdown\">\n                <li class=\"pv-h\">\n                    <label class=\"brand-label\" aria-label=\"Brand\" for=\"brand-dropdown\">Brand</label>\n                    <span id=\"brand-text\" class=\"active-brand\"></span>\n                    <span class=\"filter\"></span>\n                    <ul class=\"content filter_list_item\">\n                    <% for (var key in brands) { %>\n                        <li role=\"option\">\n                            <a href=\"#\"\n                               class=\"brand-filter\"\n                               data-slug=\"<%= brands[key].slug %>\" \n                               role=\"button\" \n                               tabindex=\"0\" \n                               aria-label=\"<%= brands[key].title %>\">\n                                <%= brands[key].title %>\n                            </a>\n                        </li>\n                    <% } %>\n                    </ul>\n                </li>\n            </ul>\n        </div>\n    <% } %>\n    <div class=\"clear-filters hide\">\n        <span>Clear All</span>\n    </div>\n</div>\n<%// END A/B TEST PLGRWEB-1380 - Browse Filter on \"All\" %>"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@5791170504500865e593a2f8b06df046f98f6aab_fetch-_osudrbz7vv3ytx7t3wrw3ceh6e/node_modules/cbs-core-ui/src/js/templates/__browseFilterDropBox.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; // START A/B TEST PLGRWEB-1380 - Browse Filter on "All" 

    ; __append("\n<div class=\"browse-filters-wrapper\">\n    <div class=\"filter-dropdown\">\n        <ul id=\"genre-dropdown\" class=\"dropdown js-dropdown\">\n            <li class=\"pv-h\">\n                <label class=\"genre-label\" aria-label=\"Genre\" for=\"genre-dropdown\">Genre</label>\n                <span id=\"genre-text\" class=\"active-genre\"></span>\n                <span class=\"filter\"></span>\n                <ul class=\"content filter_list_item\">\n                ")
    ; __line = 10
    ;  for (var key in genres) { 
    ; __append("\n                    <li role=\"option\">\n                        <a href=\"#\"\n                           class=\"genre-filter\"\n                           data-val=\"")
    ; __line = 14
    ; __append(escapeFn( genres[key].value ))
    ; __append("\"\n                           role=\"button\" \n                           tabindex=\"0\"\n                           aria-label=\"")
    ; __line = 17
    ; __append(escapeFn( genres[key].title ))
    ; __append("\">\n                            ")
    ; __line = 18
    ; __append(escapeFn( genres[key].title ))
    ; __append("\n                        </a>\n                    </li>\n                ")
    ; __line = 21
    ;  } 
    ; __append("\n                </ul>\n            </li>\n        </ul>\n    </div>\n    ")
    ; __line = 26
    ;  if (brands) { 
    ; __append("\n        <div class=\"filter-dropdown\">\n            <ul id=\"brand-dropdown\" class=\"dropdown js-dropdown\">\n                <li class=\"pv-h\">\n                    <label class=\"brand-label\" aria-label=\"Brand\" for=\"brand-dropdown\">Brand</label>\n                    <span id=\"brand-text\" class=\"active-brand\"></span>\n                    <span class=\"filter\"></span>\n                    <ul class=\"content filter_list_item\">\n                    ")
    ; __line = 34
    ;  for (var key in brands) { 
    ; __append("\n                        <li role=\"option\">\n                            <a href=\"#\"\n                               class=\"brand-filter\"\n                               data-slug=\"")
    ; __line = 38
    ; __append(escapeFn( brands[key].slug ))
    ; __append("\" \n                               role=\"button\" \n                               tabindex=\"0\" \n                               aria-label=\"")
    ; __line = 41
    ; __append(escapeFn( brands[key].title ))
    ; __append("\">\n                                ")
    ; __line = 42
    ; __append(escapeFn( brands[key].title ))
    ; __append("\n                            </a>\n                        </li>\n                    ")
    ; __line = 45
    ;  } 
    ; __append("\n                    </ul>\n                </li>\n            </ul>\n        </div>\n    ")
    ; __line = 50
    ;  } 
    ; __append("\n    <div class=\"clear-filters hide\">\n        <span>Clear All</span>\n    </div>\n</div>\n")
    ; __line = 55
    ; // END A/B TEST PLGRWEB-1380 - Browse Filter on "All" 

  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@5791170504500865e593a2f8b06df046f98f6aab_fetch-_osudrbz7vv3ytx7t3wrw3ceh6e/node_modules/cbs-core-ui/src/js/templates/__browseFilterDropBox.tpl"

}